import { atom } from "jotai"
export const photoExtentionAtom = atom("")
export const photoMaxSizeAtom = atom(0)
export const photoWidthAtom = atom(0)
export const photoHeightAtom = atom(0)